
















































































/* General */
import SearchableDropdownMixin from '@/mixins/searchable-dropdown.mixin'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IPersonWithEmail } from '@/api/types/response.types'

/* API */
import CustomersAPI from '@/api/modules/customers.api'
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default SearchableDropdownMixin.extend({
  name: 'IfpFilterCustomers',

  props: {
    mailboxId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      isPrefetchingLoneCustomer: false,
      customersLoaded: false,
      customers: [] as IPersonWithEmail[],
      prefetchedLoneCustomer: null as IPersonWithEmail,

      /* SearchableDropdownMixin configuration */
      allowMultipleSelections: true,
      minItemsForFilterInput: 0,
    }
  },
  computed: {
    totalOptionsCount(): number {
      return this.customers.length
    },
    filteredOptions(): IPersonWithEmail[] {
      if (this.filterQuery.length < 2) {
        return []
      }

      return this.customers
        .filter(c => {
          return (
            c.name.toLowerCase().includes(this.filterQuery.toLowerCase()) ||
            c.email.toLowerCase().includes(this.filterQuery.toLowerCase())
          )
        })
        .slice(0, 50)
    },
    exposeResults(): boolean {
      return this.filterQuery.length > 1
    },
    hasLoneCustomerSelection(): boolean {
      return this.selectedCustomers.length === 1
    },
    hasSelectedCustomers(): boolean {
      // Unvetted from backend, for eager label display...
      return this.selectedCustomers.length > 0
    },
    hasSelectedIDs(): boolean {
      // Unvetted from backend, for eager label display...
      return this.selectedIds.length > 0
    },
    hasOneSelectedID(): boolean {
      // Unvetted from backend, for eager label display...
      return this.selectedIds.length === 1
    },
    selectedCustomers(): IPersonWithEmail[] {
      if (!this.customersLoaded) {
        return []
      }
      return this.customers.filter(c => this.selectedIds.includes(c.id))
    },
    hasFilteredCustomers(): boolean {
      return this.filteredOptions.length > 0
    },
  },

  watch: {
    selectedIds: {
      immediate: true,
      handler(val) {
        // Prefetch the one customer for the value display
        if (!this.customersLoaded) {
          if (this.hasOneSelectedID) {
            this.prefetchLoneCustomer(this.selectedIds[0])
          }
        }
      },
    },
  },
  methods: {
    async getCustomers() {
      if (this.customersLoaded) {
        return
      }
      try {
        if (this.mailboxId) {
          this.customers = await MailboxesAPI.get_Customers(this.mailboxId)
        } else {
          this.customers = await CustomersAPI.get_All()
        }
        this.customersLoaded = true
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
    async prefetchLoneCustomer(id: number) {
      try {
        this.isPrefetchingLoneCustomer = true
        this.prefetchedLoneCustomer = await CustomersAPI.get_ContactInfo(id)
        return
      } catch (error) {
        // If we're here, the customer ID doesn't exist. Clear it...
        this.clearSelectedIDs()
      } finally {
        this.isPrefetchingLoneCustomer = false
      }
    },
  },
})
